import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// @ts-nocheck
import React from "react";
import { gql, useQuery } from "@apollo/client";
import { useHistory } from "react-router-dom";
import { Typography, Grid, Divider, Loader, Tabs, Tab, TabPanel, ErrorHandling, useMediaQuery, useTheme, makeStyles, } from "../components/mui";
import { ContentTypography } from "../components/common/content";
import AppLayout from "./common/AppLayout";
import { AppMode, chatType } from "../utils/enums";
import ColorModeContext from "../routes/ColorModeContext";
import RouteConstants from "../routes/RouteConstants";
import constants from "../utils/constants";
import { Activity } from "../components/Dashboard";
import { Chats } from "../components/Chats";
export var DashboardView;
(function (DashboardView) {
    DashboardView["Chats"] = "Chats";
    DashboardView["Activity"] = "Activity";
})(DashboardView || (DashboardView = {}));
const useStyles = makeStyles((theme) => ({
    tabs: {
        width: "100%",
    },
}));
const USER_ACTIVITIES = gql `
  query UserActivity {
    currentUser {
      id
      platformSettings {
        mode
      }
    }
    activities {
      label
      value
      path
    }
    currentOrganization {
      id
      primaryTheme
      notifications {
        id
        label
      }
      integrations {
        id
        name
        type
        active
      }
    }
  }
`;
const DashboardContainer = (props) => {
    const history = useHistory();
    const classes = useStyles();
    const theme = useTheme();
    const mdMatches = useMediaQuery(theme.breakpoints.down("md"));
    const colorMode = React.useContext(ColorModeContext);
    const [tabValue, setTabValue] = React.useState(DashboardView.Activity);
    const { loading, error, data } = useQuery(USER_ACTIVITIES);
    React.useEffect(() => {
        const userId = localStorage.getItem("userId") || null;
        const organizationId = localStorage.getItem("organizationId") || null;
        if (!userId || !organizationId) {
            return history.push(RouteConstants.Login.path);
        }
    }, []);
    React.useEffect(() => {
        if (data) {
            colorMode.defaultMode({
                mode: data?.currentUser?.platformSettings?.mode || AppMode.light,
            });
            colorMode.togglePrimaryTheme({
                color: data?.currentOrganization?.primaryTheme || constants.DEFAULT_PRIMARY_THEME,
            });
            if (data?.currentOrganization?.integrations?.length > 0 &&
                data?.currentOrganization?.integrations.some((integration) => integration?.active && Object.values(chatType).includes(integration?.type))) {
                setTabValue(DashboardView.Chats);
            }
            else {
                setTabValue(DashboardView.Activity);
            }
        }
    }, [data]);
    if (loading)
        return _jsx(Loader, {});
    if (error)
        return _jsx(ErrorHandling, { error: error });
    let showAcitivty = data?.activities?.length > 0 || data?.currentOrganization?.notifications?.length > 0;
    let showChats = data?.currentOrganization?.integrations?.length > 0 &&
        data?.currentOrganization?.integrations?.some((integration) => integration?.active && Object.values(chatType)?.includes(integration.type));
    let showWelcome = !showAcitivty && !showChats;
    return (_jsx(AppLayout, { children: _jsx(Grid, { container: true, sx: { p: mdMatches ? 1 : 4 }, spacing: 1, direction: "row", children: showWelcome ? (_jsx(Grid, { item: true, children: _jsx(ContentTypography, { align: "center", variant: "h2", color: "primary", m: mdMatches ? 10 : 24, field: "dashboardWelcomeLabel" }) })) : (_jsxs(React.Fragment, { children: [_jsx(Grid, { item: true, xs: 12, children: _jsx(ContentTypography, { align: "right", variant: "h5", color: "primary", m: 1, fontWeight: "bold", field: "dashboardLabel" }) }), _jsx(Grid, { item: true, xs: 12, sm: 12, children: _jsx(Divider, { flexItem: true }) }), _jsxs(Grid, { item: true, xs: 12, className: classes.tabs, children: [_jsxs(Tabs, { value: tabValue, onChange: (event, newValue) => {
                                    setTabValue(newValue);
                                }, textColor: "primary", indicatorColor: "primary", variant: "scrollable", scrollButtons: false, children: [showChats && (_jsx(Tab, { value: DashboardView.Chats, label: _jsx(Grid, { container: true, direciton: "row", alignItems: "center", justifyContent: "center", children: _jsxs(Typography, { variant: "subtitle2", fontWeight: "bold", sx: { textTransform: "none" }, children: ["\u00A0", DashboardView.Chats] }) }) })), showAcitivty && (_jsx(Tab, { value: DashboardView.Activity, label: _jsx(Grid, { container: true, direciton: "row", alignItems: "center", justifyContent: "center", children: _jsxs(Typography, { variant: "subtitle2", fontWeight: "bold", sx: { textTransform: "none" }, children: ["\u00A0", DashboardView.Activity] }) }) }))] }), showChats && (_jsx(TabPanel, { value: tabValue, index: DashboardView.Chats, children: _jsx(Chats, { integrations: data?.currentOrganization?.integrations.filter((integration) => integration?.active && Object.values(chatType).includes(integration?.type)) }) })), showAcitivty && (_jsx(TabPanel, { value: tabValue, index: DashboardView.Activity, children: _jsx(Activity, { activities: data?.activities || [], currentOrganization: data?.currentOrganization }) }))] })] })) }) }));
};
export default DashboardContainer;
